import { inject, Injectable, signal } from '@angular/core';
import { ApiService, ISession } from '@simac/ui';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebshopService {
  private readonly apiService = inject(ApiService);

  productCount = signal(0);
  showShoppingCartButton = signal(false);
  hasCustomPermission = false;
  dataUriMap = new Map<string, string>();

  checkAddons(session: ISession): void {
    const moduleEnabled = session?.projectInfo?.enabledFeatures?.includes('WebshopModule') ?? false;
    const hasPermission = session?.permissions?.includes('Module.Webshop.Cart.Modify') ?? false;
    this.hasCustomPermission = session.permissions?.includes('Module.Webshop.Cart.CustomModify') ?? false;
    this.showShoppingCartButton.set(moduleEnabled && (hasPermission || this.hasCustomPermission));
    if (moduleEnabled && (hasPermission || this.hasCustomPermission)) {
      this.setCounter();
    }
  }

  setCounter(count?: number): void {
    if (count) {
      this.productCount.set(count);
    } else {
      const url = this.hasCustomPermission ? 'api/webshop/customcart/count' : 'api/webshop/cart/count';
      this.apiService
        .get<number>(url)
        .pipe(take(1))
        .subscribe((result) => {
          this.productCount.set(result);
        });
    }
  }

  addDataUri(key: string, dataUri: string): void {
    this.dataUriMap.set(key, dataUri);
  }

  getDataUri(key: string): string | undefined {
    return this.dataUriMap.get(key);
  }
}
